// Prevent default in capture phase (down the DOM) only when we're going to drop a file
// This prevents the user from dropping images in editor without our consent (image would be opened in the very same tab)
export default function preventFileDrop(e) {
  if (e.dataTransfer && Array.from(e.dataTransfer.types).indexOf('Files') !== -1) {
    e.dataTransfer.dropEffect = 'none'
    e.preventDefault()
  }
}
